import { CacheConfig } from '../interfaces/cache-config.interface';

export const defaultConfig: CacheConfig = {
    keyPrefix: ''
};
